import React, { useEffect } from "react";
import { TableV2 } from "@anchor/react-components/dist/lib/components";
import Loading from "../Loading";

// createdOn is "DD/MM/YYYY, HH:MM:SS"; the default string sort orders it by day first.
const toTimestamp = (str) => {
  const m = /^(\d+)\/(\d+)\/(\d+),\s*(\d+):(\d+):(\d+)/.exec(str || "");
  return m ? new Date(+m[3], m[2] - 1, +m[1], +m[4], +m[5], +m[6]).getTime() : 0;
};
const sortByCreatedOn = (a, b, id) => toTimestamp(a.getValue(id)) - toTimestamp(b.getValue(id));

function PostmortemsTable({
  dataLoading,
  tableData,
  setPg,
  setPgSize,
  pg,
  pgSize,
  totalData,
  userAccessLoading,
  showPagination,
  userIsAdmin,
  callingFor,
  sorting,
  height,
}) {
  // {
  //   accessorKey: "customID",
  //   header: "Custom ID",
  //   id: "customID",

  //   meta: {
  //     type: "custom",
  //   },
  // },

  console.log("tableData", tableData);

  const [data, setData] = React.useState(tableData);

  useEffect(() => {
    setData(tableData);
  }, [tableData]);

  let columnData = [
    {
      accessorKey: "incidentID",
      alignData: "right",
      header: "Incident ID",
      id: "incidentID",
      meta: {
        type: "custom",
      },
    },
    {
      accessorKey: "problemID",
      alignData: "right",
      header: "Problem ID",
      id: "problemID",
      meta: {
        type: "custom",
      },
    },
    {
      accessorKey: "priority",
      alignData: "right",
      header: "Priority",
      id: "priority",
      meta: {
        type: "custom",
      },
    },
    {
      accessorKey: "createdOn",
      alignData: "right",
      header: "Created On",

      id: "createdOn",
      meta: {
        type: "custom",
      },
      enableSorting: true,
    },
    {
      accessorKey: "cmdb_ci",
      alignData: "right",
      header: "Impacted CI",
      id: "cmdb_ci",
      meta: {
        type: "custom",
      },
      enableSorting: false,
    },
    {
      accessorKey: "caused_by_ci",
      alignData: "right",
      header: "Caused By CI",
      id: "caused_by_ci",
      meta: {
        type: "custom",
      },
      enableSorting: false,
    },
    {
      accessorKey: "portfolio",
      alignData: "right",
      header: "Caused By Portfolio",
      id: "portfolio",

      meta: {
        type: "custom",
      },
      size: 190,
      minSize: 190,
      headerStyle: {
        whiteSpace: "nowrap",
        overflow: "visible",
      },
    },
    {
      accessorKey: "state",
      alignData: "right",
      header: "Status",
      id: "state",
      meta: {
        type: "custom",
      },
    },
    {
      accessorKey: "assigned_to",
      alignData: "right",
      header: "Assigned To",
      id: "assigned_to",
      meta: {
        type: "custom",
      },
      enableSorting: false,
    },
  ];

  if (callingFor === "ongoing") {
    columnData = columnData.filter((column) => column.id !== "problemID");
  }

  // Ongoing postmortems: Report + Upload Artifacts + Edit are consolidated into one "Actions" column.
  // Archived/history keep their own simpler column set (unchanged).
  if (callingFor === "ongoing" || callingFor === "archived") {
    columnData.push({
      accessorKey: "actions",
      alignData: "center",
      header: "Actions",
      id: "actions",
      meta: {
        type: "custom",
      },
      enableSorting: false,
      size: 90,
      minSize: 90,
    });
  } else {
    columnData.push({
      accessorKey: "report",
      alignData: "right",
      header: "Report",
      id: "report",
      meta: {
        type: "custom",
      },
      enableSorting: false,
    });
  }

  if (callingFor === "history") {
    // sequenceNumber: sequenceNo,
    //           changedField: baseKey,
    //           changedValue: value,
    //           time: updatedAt,
    //           changedBy: updatedBy,
    //           viewChange
    // "sequenceNumber"
    let requiredKeys = ["changedField", "time", "changedBy", "viewChange"];

    // columnData = columnData.filter((column) => {
    //   return requiredKeys.includes(column.accessorKey);
    // })
    columnData = [];
    requiredKeys.forEach((key) => {
      if (!columnData.some((column) => column.accessorKey === key)) {
        columnData.push({
          accessorKey: key,
          alignData: "right",
          header: key,
          id: key,
          meta: {
            type: "custom",
          },
          enableSorting: true,
        });
      }
    });
  }

  columnData = columnData.map((column) => ({
    ...column,
    enableSorting: column.id === "createdOn",
    ...(column.id === "createdOn" && { sortingFn: sortByCreatedOn }),
  }));

  // useEffect(() => {
  //   // Apply styles conditionally when applyStyles state changes
  //   if (userIsAdmin) {
  //     document.body.classList.add("userIsAdmin");
  //   } else {
  //     document.body.classList.remove("userIsAdmin");
  //   }
  // }, [userIsAdmin]);

  return (
    <>
      <TableV2
        stickyHeader="true"
        maxHeight={height ? height : "600"}
        style={{ width: "200px" }}
        customTableBody={
          tableData === null ? (
            dataLoading ? (
              <Loading />
            ) : (
              <p className="mds-text mds-text--medium-normal" style={{ textAlign: "center", padding: "24px 0" }}>
                Fetching Data!
              </p>
            )
          ) : dataLoading ? (
            <Loading />
          ) : tableData.length === 0 ? (
            <p className="mds-text mds-text--medium-normal" style={{ textAlign: "center", padding: "24px 0" }}>
              Data not found!
            </p>
          ) : null
        }
        // maxWidth="900"
        fit="small"
        columnData={columnData}
        defaultData={data}
        gridLine="horizontal"
        onInputChange={function noRefCheck() {}}
        onPageChange={(number) => setPg(number)}
        onPageSizeOptionsChange={(size) => setPgSize(size)}
        onRowClickCallback={function noRefCheck() {}}
        onRowExpandedCallback={function noRefCheck() {}}
        onRowSelection={function noRefCheck() {}}
        showPagination={showPagination}
        pageSizeOptions={[10, 20, 30, 50]}
        currentPage={pg}
        pageSize={pgSize}
        totalPages={Math.ceil(totalData / pgSize)}
          onSorting={(sort) => sorting(sort)}
      />
    </>
  );
}

export default PostmortemsTable;
